import { CommonModule } from '@angular/common';

import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

import { ActReferenceListComponent } from './act-reference-list.component';

@NgModule({
  declarations: [ActReferenceListComponent],
  imports: [CommonModule, MatButtonModule],
  exports: [ActReferenceListComponent]
})
export class ActReferenceListModule {}
